import { render, staticRenderFns } from "./CircularContainer.vue?vue&type=template&id=65dd8c50&"
import script from "./CircularContainer.vue?vue&type=script&lang=js&"
export * from "./CircularContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports